module.exports = __webpack_public_path__ + "img/forget-password-image.4360aa97.png";